import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import VerticalSpacer from '../VerticalSpacer';

const form = theme => ({
    display: 'flex',
    alignItems: 'baseline',
    marginBottom: theme.spacing(3),
    '&:last-child': {
        marginBottom: 0
    }
});
const styles = theme => ({
    formRow: {
        ...form(theme)
    },
    formRowLeft: {
        ...form(theme),
        justifyContent: 'flex-end'
    },
    formRowCenter: {
        ...form(theme),
        justifyContent: 'center'
    }
});

const FormRow = ({ classes, children, heading, subheading, leftAligh, alignCenter }) => {
    let childcss = classes.formRow;
    if (leftAligh) {
        childcss = classes.formRowLeft;
    }
    if (alignCenter) {
        childcss = classes.formRowCenter;
    }
    return (
        <>
            {heading && (
                <Typography variant="subtitle1" gutterBottom>
                    {heading}
                </Typography>
            )}
            {subheading && (
                <Typography className={classes.formSubheading} variant="body2">
                    {subheading}
                </Typography>
            )}
            {(heading || subheading) && <VerticalSpacer />}
            <div className={childcss}>{children}</div>
        </>
    );
};

FormRow.propTypes = {
    children: PropTypes.node.isRequired,
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    heading: PropTypes.string,
    subheading: PropTypes.string,
    leftAligh: PropTypes.bool,
    alignCenter: PropTypes.bool
};

FormRow.defaultProps = {
    heading: '',
    subheading: '',
    leftAligh: false,
    alignCenter: false
};

export default withStyles(styles, { withTheme: true })(FormRow);
